const _buildOnlyError = name => {
  throw new Error(name + " is a build-only config option and cannot be accessed at runtime");
};
import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  loadWhisperCore: false,
  type: 'application',
  auth: 'none',
  get additionalDlbs() {
    _buildOnlyError("additionalDlbs");
  },
  logFetchErrors: {
    options: {
      ignoreErrors: []
    }
  },
  htmlTitle: 'Customer Portal Application',
  htmlTitleLangKey: 'app.htmlTitle',
  historyBasename: '/:basename'
});